import React from 'react';
import { pricingConfig } from '../form/formConfig';
import { formConfig } from '../form/formConfig';

/**
 * Component to display a detailed breakdown of thetuinhuis price
 */
export const PriceBreakdown = ({ formValues }) => {
  const breakdown = [];
  let totalPrice = pricingConfig.basePrice;

  // Base price
  breakdown.push({
    label: 'Basisprijstuinhuis',
    value: pricingConfig.basePrice,
    description: 'Standaardtuinhuis constructie'
  });

  // Calculate each component
  Object.keys(pricingConfig.priceRules).forEach(fieldName => {
    const rule = pricingConfig.priceRules[fieldName];
    const value = formValues[fieldName];
    const field = formConfig.find(f => f.name === fieldName);

    if (value !== undefined && value !== null) {
      let contribution = 0;
      let description = '';

      switch (rule.type) {
        case 'linear':
          contribution = rule.formula(value, rule.baseValue, rule.pricePerUnit);
          const diff = value - rule.baseValue;
          description = diff > 0
            ? `+${(diff / 1000).toFixed(1)}m extra breedte`
            : diff < 0
            ? `${(diff / 1000).toFixed(1)}m minder dan standaard`
            : 'Standaard breedte';
          break;

        case 'perUnit':
          contribution = rule.formula(value, rule.pricePerUnit);
          description = `${value} stuks × €${rule.pricePerUnit}`;
          break;

        case 'materialPrice':
          contribution = rule.formula(value, rule.prices);
          description = `Materiaal: ${value}`;
          break;

        case 'colorPrice':
          contribution = rule.formula(value, rule.prices);
          const option = field?.options?.find(opt => opt.code === value);
          description = option ? option.label : value;
          break;

        default:
          contribution = 0;
      }

      totalPrice += contribution;

      if (contribution !== 0) {
        breakdown.push({
          label: field?.label || fieldName,
          value: contribution,
          description: description
        });
      }
    }
  });

  return (
    <div className="space-y-3">
      <p className="text-sm text-gray-600 mb-4">
        Onderstaand vindt u een gedetailleerd overzicht van de prijsopbouw van uwtuinhuis configuratie.
      </p>

      {breakdown.map((item, index) => (
        <div key={index} className="flex justify-between items-start py-2 border-b border-gray-200/60 last:border-0">
          <div className="flex-1">
            <div className="font-medium text-gray-900 text-sm">{item.label}</div>
            {item.description && (
              <div className="text-xs text-gray-600 mt-0.5">{item.description}</div>
            )}
          </div>
          <div className={`font-semibold text-sm whitespace-nowrap ml-4 ${
            item.value >= 0 ? 'text-gray-900' : 'text-green-600'
          }`}>
            {item.value >= 0 ? '+' : ''}€ {item.value.toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </div>
        </div>
      ))}

      <div className="flex justify-between items-center pt-3 mt-3 border-t-2 border-gray-900">
        <div className="font-bold text-gray-900">Totaalprijs (excl. BTW)</div>
        <div className="font-bold text-lg text-gray-900">
          € {totalPrice.toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
        </div>
      </div>

      <div className="flex justify-between items-center text-sm">
        <div className="text-gray-600">BTW (21%)</div>
        <div className="text-gray-600">
          € {(totalPrice * 0.21).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
        </div>
      </div>

      <div className="flex justify-between items-center pt-2 border-t border-gray-300">
        <div className="font-bold text-gray-900 text-lg">Totaalprijs (incl. BTW)</div>
        <div className="font-bold text-xl text-gray-900">
          € {(totalPrice * 1.21).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
        </div>
      </div>

      <div className="mt-4 p-3 bg-gray-50 rounded-lg">
        <p className="text-xs text-gray-600">
          <strong>Let op:</strong> Dit is een indicatieve prijs gebaseerd op uw configuratie.
          De definitieve prijs wordt bevestigd na bespreking van uw specifieke wensen en situatie.
        </p>
      </div>
    </div>
  );
};
